
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
@Component
export default class SingleMulHeader extends Vue {
  @Prop({ default: true }) readonly excelShow!: boolean;
  @Prop({ default: () => {} }) readonly dataFrom!: any;
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ default: false }) readonly isRange!: boolean;
  @Prop({ default: () => null }) readonly toPdf!: Function;
  updateSelect() {
    this.dataFrom.app_ids = [];
  }
  getAppList() {
    return (this as any).app_list.filter(
      (el: any) => this.dataFrom.platid == el.platform
    );
  }
  handleClick() {
    this.$emit("search", {
      platid_list: (this as any).plat_list,
      appid_list: (this as any).app_list,
    });
  }
  initFunc() {
    this.dataFrom.platid = (this as any).getinitPlatId();
    this.handleClick();
  }
  created() {
    this.initFunc();
  }
}
